// One visitor-country lookup per browser session, shared by every caller.
//
// useCurrency, useCourseDiscountRule, the trending-section geoService,
// SidebarRight, PopupCourseCards and EnrollPayment each used to call
// ipinfo.io themselves, so a single course page made up to four identical
// geo requests (plus React Query retries) before showing prices. This keeps
// one in-flight promise per page and caches the answer in sessionStorage.
const GEO_URL = "https://ipinfo.io/json?token=9da91c409ab4b2";
const STORAGE_KEY = "hachion.geoCountry";

let pending = null;

function readCached() {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

// Resolves to an upper-case ISO 3166-1 alpha-2 code; "US" if the lookup fails.
export function getVisitorCountry() {
  if (typeof window === "undefined") return Promise.resolve("US");
  const cached = readCached();
  if (cached) return Promise.resolve(cached);
  if (!pending) {
    pending = fetch(GEO_URL)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        const code = (data?.country || "US").toUpperCase();
        try {
          sessionStorage.setItem(STORAGE_KEY, code);
        } catch {
          // storage unavailable (private mode etc.) - in-memory promise still dedupes
        }
        return code;
      })
      .catch(() => {
        pending = null; // allow a later retry
        return "US";
      });
  }
  return pending;
}
